import Cirkels from "./Cirkels"
import Legend from "./Legend"
import Defs from "./Defs"


export default function Cirkelvisualisatie({ settings, data, iconPositions, connectionChains,
  circleWidth, middleRadius, clickSelection, setClickSelection, linkPathsPerIcon,
  chainSelection, setChainSelection, chartClicked, hoverSelection,
  setHoverSelection, circleWidthImpacts, partijenOptions, landschapOptions,
  setLandschapOptions, setPartijenOptions }) {

  // deselect with escape key
  document.addEventListener('keydown', function(e){if(e.code === 'Escape'){chartClicked()}});

  // determine svg width
  let svgWidth = 0;
  let divSysteem = document.querySelector('.Systeem');
  if(divSysteem !== null){
    svgWidth = divSysteem.offsetWidth;
  }

  return (
    <div className="Systeem" role="group" aria-label="Droogtevisualisatie: Klik op de knop 'Opties voor toegankelijkheid openen' voor een tekstalternatief.">

      <svg className="svg_cirkelvisualisatie" width={'100%'} height={'auto'} tabIndex='0'
        viewBox={`0 0 ${svgWidth} ${settings.height}`} aria-hidden='true'>
        {/* <title>Droogtevisualisatie. Klik op de knop (Open) Menu linksboven voor een tekstueel alternatief</title> */}

        <Defs />

        <rect width={svgWidth} height={settings.height}
          onClick={() => chartClicked()} opacity='0'/>

        <Cirkels settings={settings} data={data} iconPositions={iconPositions}
        connectionChains={connectionChains} circleWidth={circleWidth}
        middleRadius={middleRadius} clickSelection={clickSelection}
        setClickSelection={setClickSelection} linkPathsPerIcon={linkPathsPerIcon}
        hoverSelection={hoverSelection} setHoverSelection={setHoverSelection}
        chartClicked={chartClicked} svgWidth={svgWidth}
        chainSelection={chainSelection} setChainSelection={setChainSelection}
        circleWidthImpacts={circleWidthImpacts}
        partijenOptions={partijenOptions} setPartijenOptions={setPartijenOptions}
        landschapOptions={landschapOptions} setLandschapOptions={setLandschapOptions} />

        <Legend chainSelection={chainSelection} clickSelection={clickSelection}
          hoverSelection={hoverSelection} svgWidth={svgWidth} data={data}
          connectionChains={connectionChains} />

      </svg>

    </div>
  );
}
